enum PublishActions {
    PUBLISH_CLIP_SAGA = 'timeline/publish/PUBLISH_VOD_SAGA',
}

export { PublishActions };
